import React from 'react';

const ChipInfo = ({text, onClose, direction}) => {

  const close = () => {
    if(!!onClose) onClose();
  };

  return (
    <div className={`mainDropdown  visible`}>
      <div className={`menuList chipAmount playersChips ${direction} `}>
        {text}
      </div>
      <div className={`transparentMask`} 
        onClick={close}>
      </div>
    </div>
  )
}

export default ChipInfo;